module.exports = __webpack_public_path__ + "img/one_single.bc44b591.png";